import React from 'react';
import { VendeSinVenderLanding } from './pages/VendeSinVenderLanding';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <VendeSinVenderLanding data-id="element-1" />
    </div>;
}